(() => {
  'use strict';
  const node = document.getElementById('bcrs-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const root = window.Shopify.routes.root;
  let queue = Promise.resolve();
  let checkingOut = false;
  let allowedForm = null;
  let allowedLink = null;
  const enqueue = (task) => {
    const next = queue.then(task, task);
    queue = next.catch(() => {});
    return next;
  };
  const expectedUnits = (cart) => cart.items.reduce((sum, item) => sum + (config.units[String(item.variant_id)] || 0) * item.quantity, 0);
  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { cache: 'no-store' });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  };
  const post = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  };
  const reconcile = async () => {
    let cart = await getCart();
    const count = expectedUnits(cart);
    const deposits = cart.items.filter((item) => String(item.variant_id) === String(config.depositVariant));
    let changed = false;
    if (deposits.length) {
      const updates = {};
      deposits.forEach((item, index) => {
        const quantity = index === 0 ? count : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (Object.keys(updates).length) {
        cart = await post('cart/update.js', { updates });
        changed = true;
      }
    } else if (count > 0) {
      await post('cart/add.js', { items: [{ id: config.depositVariant, quantity: count }] });
      cart = await getCart();
      changed = true;
    }
    const paid = cart.items.filter((item) => String(item.variant_id) === String(config.depositVariant));
    if (paid.reduce((sum, item) => sum + item.quantity, 0) !== expectedUnits(cart)) throw new Error(config.error);
    if (paid.some((item) => item.taxable || item.original_price !== 10 || item.final_line_price !== item.quantity * 10)) throw new Error(config.discountError);
    return { cart, changed };
  };
  const sectionNames = (options) => {
    const body = options && options.body;
    const value = body instanceof FormData ? body.get('sections') : typeof body === 'string' ? JSON.parse(body).sections : null;
    return Array.isArray(value) ? value : value ? value.split(',') : [];
  };
  const request = (url, options) => enqueue(async () => {
    const response = await fetch(url, options);
    if (!response.ok) return response;
    const data = await response.clone().json();
    const { cart } = await reconcile();
    const names = [...new Set(sectionNames(options))].slice(0, 5);
    let sections = data.sections;
    if (names.length) {
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('sections', names.join(','));
      const rendered = await fetch(sectionUrl, { cache: 'no-store' });
      if (!rendered.ok) throw new Error(config.error);
      sections = await rendered.json();
      if (names.some((name) => typeof sections[name] !== 'string')) throw new Error(config.error);
    }
    const updated = Array.isArray(data.items) && 'item_count' in data ? cart : data;
    updateAccelerated(cart);
    return new Response(JSON.stringify({ ...updated, sections }), { status: response.status, headers: { 'Content-Type': 'application/json' } });
  });
  const updateAccelerated = (cart) => {
    document.querySelectorAll('.dynamic-cart-btns').forEach((element) => { element.hidden = expectedUnits(cart) > 0; });
  };
  const showError = (message) => {
    let element = document.getElementById('bcrs-error');
    if (!element) {
      element = document.createElement('p');
      element.id = 'bcrs-error';
      element.setAttribute('role', 'alert');
      element.style.cssText = 'padding:12px;background:#fff0f0;color:#8b0000;position:fixed;bottom:16px;left:16px;right:16px;z-index:9999';
      document.body.append(element);
    }
    element.textContent = message || config.error;
    element.hidden = false;
  };
  const refresh = () => {
    const drawer = document.querySelector('cart-drawer');
    const items = document.querySelector('cart-items');
    if (drawer) drawer.refreshCartDrawer();
    else if (items) items.refreshCartItems();
  };
  const beforeCheckout = async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    const form = event.target instanceof HTMLFormElement ? event.target : event.target.closest('form');
    if (form && !form.checkValidity()) { form.reportValidity(); return; }
    const terms = form ? Array.from(form.elements).find((element) => element.matches('.js-cart-terms-checkbox')) : null;
    if (terms && !terms.checked) { terms.focus(); showError(config.termsError); return; }
    checkingOut = true;
    try {
      await enqueue(reconcile);
      checkingOut = false;
      if (event.type === 'submit' && form) {
        allowedForm = form;
        form.requestSubmit(event.submitter);
        allowedForm = null;
      } else {
        const link = event.target.closest('a[href]');
        allowedLink = link;
        link.click();
        allowedLink = null;
      }
    } catch (error) {
      checkingOut = false;
      showError(error.message);
      refresh();
    }
  };
  document.addEventListener('submit', (event) => {
    if (event.target === allowedForm) return;
    if (event.submitter && event.submitter.name === 'checkout') beforeCheckout(event);
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link === allowedLink) return;
    if (link && /\/checkout\/?$/.test(new URL(link.href).pathname)) beforeCheckout(event);
  }, true);
  const restore = () => enqueue(reconcile).then(({ cart, changed }) => {
    updateAccelerated(cart);
    if (changed) refresh();
  }).catch((error) => showError(error.message));
  window.BCRS = { request, expectedUnits };
  document.addEventListener('DOMContentLoaded', restore, { once: true });
  window.addEventListener('pageshow', (event) => { if (event.persisted) restore(); });
})();